'use client';

import { useBrowserAgent } from '@/hooks/useBrowserAgent';

export function BrowserAgent() {
  useBrowserAgent();

  // This component doesn't render any visible HTML
  return null;
}